"use client";
import React from "react";

interface ToggleProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "type"
> {
  label?: string;
  helperText?: string;
  errorText?: string;
  containerClassName?: string;
}

export function Toggle({
  label,
  helperText,
  errorText,
  containerClassName = "",
  className = "",
  checked,
  onChange,
  disabled,
  ...props
}: ToggleProps) {
  return (
    <div className={containerClassName}>
      <div className="flex items-center gap-3">
        <label className="inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className="sr-only peer"
            {...props}
          />
          <div
            className={`
              relative w-11 h-6 
              bg-gray-200 
              rounded-full 
              peer-focus:outline-hidden 
              peer-focus:ring-2 
              peer-focus:ring-blue-500 
              peer-checked:bg-blue-500
              after:content-[''] 
              after:absolute 
              after:top-[2px] 
              after:left-[2px] 
              after:bg-white 
              after:border-gray-300 
              after:border 
              after:rounded-full 
              after:h-5 
              after:w-5 
              after:transition-all
              peer-checked:after:translate-x-full 
              peer-checked:after:border-white
              ${disabled ? "opacity-50 cursor-not-allowed" : ""}
              ${className}
            `}
          />
          {label && (
            <span
              className={`ml-3 text-sm text-gray-700 ${
                disabled ? "opacity-50" : ""
              }`}
            >
              {label}
            </span>
          )}
        </label>
      </div>
      {errorText && (
        <div className="mt-1 ml-1 text-error text-sm">{errorText}</div>
      )}
      {helperText && (
        <div className="mt-1 ml-1 text-gray-600 text-sm">{helperText}</div>
      )}
    </div>
  );
}
